import styled from '@emotion/styled';
import { Button } from 'antd';

export const StyledMoreActionsButton = styled(Button)`
	padding-inline-start: 12px !important;
	padding-inline-end: 12px !important;
	margin-left: 0;
`;
